/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_AmountInputs */

const en_editor_ingredient_amount = /** @type {(inputs: Editor_Ingredient_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const de_editor_ingredient_amount = /** @type {(inputs: Editor_Ingredient_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Editor_Ingredient_AmountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_amount = /** @type {((inputs?: Editor_Ingredient_AmountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_AmountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_amount(inputs)
	return en_editor_ingredient_amount(inputs)
});